import React, { useState } from "react";
import styles from './styles.module.scss'


function LoadDetailsMacroPoint(props) {
    const [isToggled, setToggled] = useState(false)
    const toggleTrueFalse = () => setToggled(!isToggled)

  // The macropoint payload is now an object ({ current, pings }); iterate the pings array.
  const pings = (props.data && props.data.pings) || []

  const macroPointDisplay = pings.map((x) => {
    const [datePart, timePartRaw] = (x.event_happened_at || '').split('T')
    const timeFormatted = timePartRaw ? timePartRaw.replace(/([+-]\d{2}:?\d{2}|Z)$/, '') : ''
      return(
        <div className={styles.row} key={`${x.event_happened_at}-${x.latitude},${x.longitude}`}>
          <div>
            <strong>Date:</strong> {datePart} <br/>
            <strong>Time:</strong> {timeFormatted}
          </div>
          <div>
            <strong>City:</strong> {x.city} <br/>
            <strong>State:</strong> {x.region}
          </div>
        </div>
      )
    })

    let showMoreMacroPoint, display, showSeeMoreOption
    const dataIsLoaded = pings.length > 0
    if (dataIsLoaded) {
      if (isToggled) {
        //display all macropoint data
        showMoreMacroPoint = macroPointDisplay
        display = 'Show less...'
      } else {
        //display 1 single latest macropoint update
        showMoreMacroPoint = macroPointDisplay[0]
        display = 'Show more...'
      }
      if (macroPointDisplay.length > 1) {
        showSeeMoreOption = <button className={styles.seeMoreButton} onClick={toggleTrueFalse}> {display} </button>
      }
    }

  return (
    <div>
      <div className={styles.container}>
        {showMoreMacroPoint}
      </div>
      {showSeeMoreOption}
    </div>
  )
}

export default LoadDetailsMacroPoint
